<mat-card class="flex-col standard-content">
  <div class="flex-row">
    <div class="flex-col flex-justify-start flex-align-center standard-card-image-wrapper">
      <a routerLink="{{ content().permalink }}">
        <img class="standard-news-image" src="{{ content().pathFoto }}" />
      </a>
    </div>
    <mat-card-title-group class="flex-col flex-row-100"
      [ngClass]="isHomeCard() ? 'flex-justify-space-evenly' : 'flex-justify-space-between'">
      <mat-card-title class="dottnet-card-title standard-title">
        <h2>
          @if (content().premium) {
          <img class="icona-premium" src="assets/premium.png" /> }@if (content().template === 'articolo-riservato') {
          <mat-icon>https</mat-icon> }<a routerLink="{{ content().permalink }}">
            {{ content().titolo }}</a>
        </h2>
      </mat-card-title>
      <mat-card-subtitle class="dottnet-card-subtitle standard-header">
        <a href="topic/{{ content().descrizioneTopic | urlClean }} ">{{ content().descrizioneTopic }} </a>| {{
        content().autore }} |
        {{ content().dataCreazione | date : 'dd/MM/yyyy HH:mm' : 'UTC' }}</mat-card-subtitle>
    </mat-card-title-group>
  </div>
  <mat-card-content>
    <div class="dottnet-card-eyelet standard-eyelet flex-col">
      <p>
        {{ content().occhiello }}
      </p>
    </div>
  </mat-card-content>
</mat-card>